import { render, staticRenderFns } from "./SelectModel.vue?vue&type=template&id=0a57680b&scoped=true&"
import script from "./SelectModel.vue?vue&type=script&lang=js&"
export * from "./SelectModel.vue?vue&type=script&lang=js&"
import style0 from "./SelectModel.vue?vue&type=style&index=0&id=0a57680b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a57680b",
  null
  
)

export default component.exports